import axios from "axios";
import { useCallback, useState } from "react";
import { URL } from "../../config";
import { useSelector } from "react-redux";

const UpdateUserImage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [data, setData] = useState(null);
    const {token}=useSelector((state)=>state.AuthReducer);
    const makeRequest = useCallback(async (requestData) => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.post(`${URL}/api/profile/changeImage`, requestData,{
            headers:{
                Authorization:`Bearer ${token}`,
                'Accept':'application/json',
                "Content-Type": "multipart/form-data",
            }});
        setData(response.data);
        setSuccess(true)
      } catch (err) {
        setError(err);
      }
      setIsLoading(false);
    }, [token]);
  
    return { makeRequest, data, isLoading, error,success };
}

export default UpdateUserImage